"use client";

import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const contactItems = [{
    icon: Phone,
    text: "Phone: (203) 872-9965",
    href: "tel:+11234567890"
  }, {
    icon: Mail,
    text: "Email: info@carserviceconnecticut.com",
    href: "mailto:info@carserviceconnecticut.com"
  }, {
    icon: MapPin,
    text: "Headquarters: 123 Church St, New Haven, CT 06510",
    href: "#"
  }];
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }];
  const quickLinks = [{
    label: "Home",
    href: "/HomePage"
  }, {
    label: "Services",
    href: "/ServicesPage"
  }, {
    label: "Fleet",
    href: "/FleetPage"
  }, {
    label: "Airports We Service",
    href: "/AirportsWeServicePage"
  }, {
    label: "Locations We Serve",
    href: "/LocationsWeServePage"
  }, {
    label: "Contact",
    href: "/ContactPage"
  }, {
    label: "Terms and Conditions",
    href: "/TermsAndConditionsPage"
  }, {
    label: "Privacy Policy",
    href: "/PrivacyPolicyPage"
  }];
  return <footer ref={ref} className={`bg-dark-background py-12 border-t border-muted/20 transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0 shadow-strong" : "opacity-0 translate-y-4"}`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {}
          <div className="flex flex-col gap-4">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1431253/img/car_service_connecticut_footer_logo.png" alt="Car Service Connecticut" className="h-7 mb-2" />
            <div className="flex flex-col gap-3">
              {contactItems.map((item, i) => {
              const Icon = item.icon;
              return <Link key={i} to={item.href} data-index={i} className="flex items-center gap-3 text-foreground-dark/80 hover:text-foreground-dark transition-colors duration-[var(--duration-medium)] group">
                    <Icon className="size-4 text-primary group-hover:scale-110 transition-transform duration-[var(--duration-medium)]" />
                    <span className="text-sm">{item.text}</span>
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-foreground-dark font-display font-semibold text-base">
              Follow Us
            </h3>
            <div className="flex gap-3">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} to={social.href} data-index={i} newTab aria-label={social.label} className="flex items-center justify-center size-10 rounded-lg bg-primary/10 text-foreground-dark hover:bg-primary hover:text-foreground-primary transition-all duration-[var(--duration-medium)] hover:scale-110 hover:shadow-medium">
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
            <p className="text-foreground-dark/60 text-xs mt-2">
              24/7 Availability
            </p>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-foreground-dark font-display font-semibold text-base">
              Quick Links
            </h3>
            <nav className="flex flex-col gap-2">
              {quickLinks.map((link, i) => <Link key={i} to={link.href} data-index={i} className="text-foreground-dark/80 hover:text-foreground-dark transition-colors duration-[var(--duration-medium)] text-sm">
                  {link.label}
                </Link>)}
            </nav>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-muted/20 text-center">
          <p className="text-foreground-dark/60 text-xs">
            © {new Date().getFullYear()} Car Service Connecticut. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}